import RequiredDocuments from './RequiredDocuments';

export default RequiredDocuments;
